/**
 * WORK ORDERS STORE
 */

import api from "Api";

import {
    addBatchToSchedule,
    getBatchSchedule,
    deleteBatchFromSchedule,
    getBatchProductionSchedule,
} from "Modules/manufacturing/work_orders/config/api.work_orders.js";

const state = {
    page: {},
    summary_receiving: null,
    receiving: JSON.parse(localStorage.getItem("receiving")) || null,
    receiving_filter: {
        search: "",
        company_id: "",
        // in_warehouse: "",
        date_received: "",
        page_size: 0,
        page_num: 1,
        line_id: "",
    },
    continuous_filter: {
        furnace_option: null,
        pattern_number: null,
        date_scheduled: null,
        page_size: 0,
        page_num: 1,
    },
    schedule_filter: {
        furnace_option: null,
        start_date: null,
    },
    patterns: [],
    part_stations: null,
    furnaces: null,
    schedule: null,
    warehouse: null,
    dashboard_work_orders_batches: null,
    work_orders_batch: null,
    work_orders_batches: JSON.parse(localStorage.getItem("work_orders_batches")) || null,
    work_order: null,
    unscheduled_work_orders: null,
    work_orders_production: null,
    work_orders: JSON.parse(localStorage.getItem("work_orders")) || null,
    work_orders_filter: {
        search: "",
        company_id: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchWorkOrder({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitWorkOrder", {
                        property: "page",
                        with: response.data.page,
                    });
                }
                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitWorkOrder", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateWorkOrder", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async saveBatchToSchedule({ rootState, commit }, payload) {
        try {
            let response = await addBatchToSchedule(payload);

            if (response.data && response.data.page) {
                commit("commitWorkOrder", {
                    property: "page",
                    with: response.data.page,
                });
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    },
    async fetchBatchSchedule({ rootState, commit }, payload) {
        try {
            let response = await getBatchSchedule(payload);

            if (response.data && response.data.page) {
                commit("commitWorkOrder", {
                    property: "page",
                    with: response.data.page,
                });
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    },
    async fetchBatchProductionSchedule({ rootState, commit }, payload) {
        try {
            let response = await getBatchProductionSchedule(payload);

            if (response.data && response.data.page) {
                commit("commitWorkOrder", {
                    property: "page",
                    with: response.data.page,
                });
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    },
    async removeBatchFromSchedule({ rootState, commit }, payload) {
        try {
            let response = await deleteBatchFromSchedule(payload);

            if (response.data && response.data.page) {
                commit("commitWorkOrder", {
                    property: "page",
                    with: response.data.page,
                });
            }

            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitWorkOrder(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateWorkOrder(state, payload) {
        if (payload.method == "post" && payload.with) {
            let curr_item = _.get(state, payload.property);
            // allows to push multiple 'with' into property
            if (curr_item == null) curr_item = [];
            curr_item.push.apply(curr_item, Array.isArray(payload.with) ? [...payload.with] : [payload.with]);
            _.set(state, payload.property, curr_item || null);
        } else if (payload.method == "patch" && payload.property && payload.with) {
            let curr_item = _.get(state, payload.property);
            if (Array.isArray(curr_item)) {
                let curr_id = payload.id ? payload.id : payload.with[payload.pk];
                curr_item = curr_item[curr_item.findIndex((obj) => obj[payload.pk] == curr_id)];
            }
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let curr_item = _.get(state, payload.property);
            curr_item.splice(
                curr_item.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetWorkOrders(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.summary_receiving = null;
        state.receiving = JSON.parse(localStorage.getItem("receiving")) || null;
        state.receiving_filter = {
            search: "",
            company_id: "",
            // in_warehouse: "",
            date_received: "",
            page_size: 0,
            page_num: 1,
        };
        state.continuous_filter = {
            furnace_option: null,
            pattern_number: null,
            date_scheduled: null,
            page_size: 0,
            page_num: 1,
        };
        state.schedule_filter = {
            furnace_option: null,
            start_date: null,
        };
        state.patterns = [];
        state.part_stations = null;
        state.furnaces = null;
        state.schedule = null;
        state.warehouse = null;
        state.dashboard_work_orders_batches = null;
        state.work_orders_batch = null;
        state.work_orders_batches = JSON.parse(localStorage.getItem("work_orders_batches")) || null;
        state.work_order = null;
        state.unscheduled_work_orders = null;
        state.work_orders_production = null;
        state.work_orders = JSON.parse(localStorage.getItem("work_orders")) || null;
        state.work_orders_filter = {
            search: "",
            company_id: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
